import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, Canceler } from 'axios';
import session from '../session';
import settings from '../settings';

export const ApiRequestIdentifier = '__maga_api_request__';
export const ApiResponseIdentifier = '__maga_api_response__';

class APIBase {
  http: AxiosInstance;
  silentHttp: AxiosInstance;

  constructor() {
    this.http = axios.create();
    this.http.defaults.headers.common['Platform'] = 'admin';
    this.http.defaults.headers.common['Platform-Version'] = settings.getVersion();

    this.http.interceptors.request.use(
      config => {
        window.dispatchEvent(new Event(ApiRequestIdentifier));

        return config;
      },
      error => Promise.reject(error),
    );

    this.http.interceptors.response.use(
      response => {
        window.dispatchEvent(new Event(ApiResponseIdentifier));

        return response;
      },
      error => {
        window.dispatchEvent(new Event(ApiResponseIdentifier));

        return Promise.reject(error);
      },
    );

    const currentSession = session.get();

    if (currentSession?.accessToken) {
      this.http.defaults.headers.common['access_token'] = currentSession.accessToken;
    }

    // omit custom headers to prevent sending a preflight request.
    this.silentHttp = axios.create();
  }

  setAccessToken(accessToken: string): void {
    this.http.defaults.headers.common['access_token'] = accessToken;
  }

  isResponseSuccess(result: AxiosResponse) {
    return !!result && String(result.status).substr(0, 1) === '2';
  }

  isCancel(e: Error) {
    return axios.isCancel(e);
  }

  getWithCancel(uri: string, config?: AxiosRequestConfig): [Promise<AxiosResponse<any>>, Canceler] {
    let cancel: Canceler = () => undefined;

    const response = this.http.get(uri, {
      ...config,
      cancelToken: new axios.CancelToken(c => (cancel = c)),
    });

    return [response, cancel];
  }
}

export default new APIBase();
